module.exports = __webpack_public_path__ + "static/media/02_03_02_up.9cf41413.png";